import { mentionDisplayLabel, type MentionCategory } from "@/components/prompt-editor/types"
import { flowNodeEntityKind, type FlowNodeRow } from "@/types/flow"

export type FlowReferenceEntityMention = {
  kind: "entity"
  category: Extract<MentionCategory, "hero" | "loc" | "prop">
  id: number
  /** Имя без @. Чип и mentionToken берут его как label. */
  name: string
  /** Подпись полоски: @Имя. */
  label: string
}

export type FlowReferenceFileMention = {
  kind: "file"
  /** @reference_N */
  label: string
}

export type FlowReferenceMention = FlowReferenceEntityMention | FlowReferenceFileMention

export type FlowReferenceSource = Pick<FlowNodeRow, "kind" | "character_id" | "location_id" | "prop_id" | "entity_name">

export function flowReferenceFileLabel(position: number): string {
  return `@reference_${position}`
}

/** Студийный ассет с именем — меншен сущности. Картинка и ассет без имени остаются @reference_N. */
export function flowReferenceMention(source: FlowReferenceSource, position: number): FlowReferenceMention {
  const file: FlowReferenceFileMention = { kind: "file", label: flowReferenceFileLabel(position) }
  if (!flowNodeEntityKind(source.kind)) return file

  const name = source.entity_name?.trim()
  if (!name) return file

  const entity = flowReferenceEntity(source)
  if (!entity) return file

  return {
    kind: "entity",
    category: entity.category,
    id: entity.id,
    name,
    label: mentionDisplayLabel(entity.category, name),
  }
}

function flowReferenceEntity(
  source: FlowReferenceSource,
): { category: FlowReferenceEntityMention["category"]; id: number } | null {
  if (source.kind === "character" && source.character_id != null) return { category: "hero", id: source.character_id }
  if (source.kind === "location" && source.location_id != null) return { category: "loc", id: source.location_id }
  if (source.kind === "prop" && source.prop_id != null) return { category: "prop", id: source.prop_id }
  return null
}
